module.exports = __webpack_public_path__ + "static/media/termsAndPolicy.2acc3ad8.svg";